/**
 * Indexatieslot van 12 maanden (besluit 4, migratie 196).
 *
 * Professional:  /api/v1/professional/tarief-contractjaar
 * Opdrachtgever: /api/v1/employer/tarief-voorstellen
 */
import api from './api';

const d = <T,>(r: { data: { data: T } }) => r.data.data;

export type TariefKeuze = 'HANDHAVEN' | 'INDEXATIE' | 'EIGEN_VOORSTEL';
export type VoorstelStatus = 'GEMELD' | 'INGEDIEND' | 'GEHANDHAAFD' | 'GOEDGEKEURD' | 'AFGEWEZEN' | 'TOEGEPAST' | 'VERLOPEN';

export interface TariefVoorstel {
  id: string;
  status: VoorstelStatus;
  keuze: TariefKeuze | null;
  organisatie: string;
  professional_naam: string;
  /** YYYY-MM-DD: einde contractjaar = ingangsdatum van een nieuw tarief */
  contractjaar_eind: string;
  dagen_resterend: number;
  huidig_tarief: number;
  huidig_effectief_tarief: number;
  korting_pct: number;
  voorgesteld_tarief: number | null;
  indexatie_pct: number | null;
  toelichting: string | null;
  afwijs_reden: string | null;
}

export const TARIEF_CONTRACTJAAR_KEY = ['tarief-contractjaar'] as const;
export const TARIEF_VOORSTELLEN_KEY = ['tarief-voorstellen'] as const;

export const tariefContractjaarApi = {
  professional: () =>
    api.get<{ data: { indexatie_pct: number | null; indexatie_bron: string | null; voorstellen: TariefVoorstel[] } }>('/v1/professional/tarief-contractjaar').then(d),
  kies: (id: string, invoer: { keuze: TariefKeuze; tarief?: number | null; toelichting?: string | null }) =>
    api.post<{ data: TariefVoorstel }>(`/v1/professional/tarief-contractjaar/${id}/keuze`, invoer).then(d),
  opdrachtgever: () =>
    api.get<{ data: { kan_besluiten: boolean; voorstellen: TariefVoorstel[] } }>('/v1/employer/tarief-voorstellen').then(d),
  besluit: (id: string, akkoord: boolean, reden?: string | null) =>
    api.post<{ data: TariefVoorstel }>(`/v1/employer/tarief-voorstellen/${id}/besluit`, { akkoord, reden: reden ?? null }).then(d),
};
